export function parse_token(token) {
    const token_parts = token.split('.')

    // const header = token_parts[0]
    const payload = token_parts[1]
    // const signature = token_parts[2]

    return JSON.parse(atob(payload))
}

export function get_selected_token(user_tokens) {
    if (!user_tokens) {
        return null
    }

    const { token_list, selected_token } = user_tokens
    return token_list[selected_token || 0]?.token
}

export function token_expired(token) {
    if (!token) {
        return true
    }
    const token_json = parse_token(token)
    return token_json_expired(token_json)

}

export function token_json_expired(token_json) {
    if (!token_json) {
        return true
    }
    const token_exp_seconds = token_json?.exp || 0
    return Date.now() >= (token_exp_seconds - 30) * 1000
}
